const getBlockIndex = (content, blockKey) => content.blocks.findIndex((block) => block.key === blockKey);

export { getBlockIndex };
//# sourceMappingURL=draftUtils.js.map
